import axios from "axios";
//Limitless imports
import { createPlatformURL, handleSecureAjaxError, createMutationHeaders } from "../../utils/SecurePlatformAPIUtils";
import { log as pilog } from "@limitless/common/utils";

/**
 * Load the Users Knowledge Libraries from the Platform
 */
export const fetchUserKnowledgeLibraries = callback => {
  const log = pilog.getLogger("KnowledgeAPI fetchUserKnowledgeLibraries");
  const url = createPlatformURL("profile/knowledge");
  axios.get(url, createMutationHeaders(null, {
    "App-Name": process.env.REACT_APP_NAME
  })).then(res => {
    log.debug("Knowledge libraries", res.data);
    const libraries = res.data.map(lib => {
      lib.displayName = lib.displayName || lib.groupName;
      return lib;
    });
    callback(libraries);
  }).catch(error => {
    handleSecureAjaxError(error, "KnowledgeAPI fetchUserKnowledgeLibraries");
    callback([]);
  });
};
export const fetchFAQSForKnowledeLibrary = (knowledgeLibrary, category, subcategory, callback) => {
  const log = pilog.getLogger("KnowledgeAPI fetchFAQSForKnowledeLibrary");
  const {
    tenantName,
    groupName,
    kbType
  } = knowledgeLibrary;
  const url = createPlatformURL(`knowledge/tenants/${tenantName}/groups/${groupName}/all_faq`);
  log.debug(`Searching for category ${category} subcategory ${subcategory}`);
  const params = {
    category: category ? category.split("|")[0] : null,
    subcategory,
    transform: true,
    kbType: kbType ? kbType : "grpMem" //Group Membership, this shouldnt be null.
  };
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug("Knowledge Subcategory FAQs ", res.data.articles);
    const faqs = res.data.articles ? res.data.articles : [];
    callback(faqs);
  }).catch(error => {
    handleSecureAjaxError(error, "KnowledgeAPI loadKnowledgeBaseFAQs");
    callback([]);
  });
};
export const searchKnowledgeLibrary = (knowledgeLibrary, searchTerm, callback) => {
  const log = pilog.getLogger("KnowledgeAPI searchKnowledgeBase");
  const {
    tenantName,
    groupName,
    kbType
  } = knowledgeLibrary;
  const url = createPlatformURL(`knowledge/tenants/${tenantName}/groups/${groupName}/search`);
  const params = {
    //eslint-disable-next-line
    search_text: searchTerm,
    kbType: kbType ? kbType : "grpMem",
    transform: true
  };
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug("Knowledge Search Results ", res.data);
    callback(res.data);
  }).catch(error => {
    handleSecureAjaxError(error, "KnowledgeAPI searchKnowledgeBase");
    callback([]);
  });
};
export const fetchCategoriesForKnowledeLibrary = (knowledgeLibrary, callback) => {
  const log = pilog.getLogger("KnowledgeAPI fetchCategoriesForKnowledeLibrary");
  const {
    tenantName,
    groupName,
    kbType
  } = knowledgeLibrary;
  const url = createPlatformURL(`knowledge/tenants/${tenantName}/groups/${groupName}/categories`);
  const params = {
    ["faq_limit"]: 10,
    kbType: kbType ? kbType : "grpMem"
  };
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug("Knowledge Categories ", res.data);
    callback(res.data || []);
  }).catch(error => {
    handleSecureAjaxError(error, "KnowledgeAPI fetchCategoriesForKnowledeLibrary");
    callback([]);
  });
};
export const fetchKnowledgeArticle = (knowledgeLibrary, article, callback) => {
  const log = pilog.getLogger("KnowledgeAPI fetchKnowledgeArticle");
  const {
    tenantName,
    groupName,
    kbType
  } = knowledgeLibrary;
  const url = createPlatformURL(`knowledge/tenants/${tenantName}/groups/${groupName}/articles/${article.label}`);
  const params = {
    kbType: kbType ? kbType : "grpMem"
  };
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug("Knowledge Article ", res.data);
    callback(res.data);
  }).catch(error => {
    handleSecureAjaxError(error, "KnowledgeAPI fetchKnowledgeArticle");
    callback(null);
  });
};